// extracted by mini-css-extract-plugin
module.exports = {"table":"list_table__1mth-","table-wrapper":"list_table-wrapper__joRJG","copy-button":"list_copy-button__3uWq3"};